import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from 'src/app/services/auth.service';
import { Auth } from '@angular/fire/auth';
import { AnnouncerModeService } from 'src/app/services/announcer-mode.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderComponent implements OnInit {
  private cd: ChangeDetectorRef = inject(ChangeDetectorRef);
  private router: Router = inject(Router);
  protected fbAuth: Auth = inject(Auth);
  protected auth: AuthService = inject(AuthService);
  protected announcerMode: AnnouncerModeService = inject(AnnouncerModeService);
  protected responsive: BreakpointObserver = inject(BreakpointObserver);
  protected hideMenu: WritableSignal<boolean> = signal(false);
  protected isMobile: WritableSignal<boolean> = signal(false);

  constructor() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe(() => {
        this._updateMenuVisibility();
      });
  }

  ngOnInit(): void {
    this._updateMenuVisibility();
    this.responsive
      .observe([Breakpoints.Handset, Breakpoints.Tablet, Breakpoints.Web])
      .subscribe((result) => {
        const breakpoints = result.breakpoints;
        if (
          breakpoints[Breakpoints.HandsetPortrait] ||
          breakpoints[Breakpoints.HandsetLandscape]
        ) {
          this.isMobile.set(true);
        } else {
          this.isMobile.set(false);
        }
        this.cd.detectChanges();
      });
  }

  private _updateMenuVisibility(): void {
    const pathname = this.router.url;
    this.hideMenu.set(
      pathname.includes('/shoutouts/create') ||
        pathname.includes('/shoutouts/kiosk'),
    );
  }

  logout(): void {
    this.auth.logout().then(() => {
      this.router.navigate(['/login']);
    });
  }
}
